export default [
  {
    name: 'searchFilters'
  }
];
